/**
 * @phxPersonalReminders
 */

angular.module('hybrid-ng-personal-reminders', []);

require('./components/personal_reminder_add_button/personal_reminder_add_button_component.es');
require('./components/expanding_reminder_textbox/expanding_reminder_textbox_component');



// WEBPACK FOOTER //
// ./app/vendor/hybrid-ng-personal-reminders/src/main.ts